import { render } from "./B2bPageEstadisticas.vue?vue&type=template&id=2bfc21ef&scoped=true&lang=pug"
import script from "./B2bPageEstadisticas.vue?vue&type=script&lang=js"
export * from "./B2bPageEstadisticas.vue?vue&type=script&lang=js"

import "./B2bPageEstadisticas.vue?vue&type=style&index=0&id=2bfc21ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfc21ef"]])

export default __exports__